/**
 * 实曝光用户浏览的图片url和点击的url
 */
import watchExpDot from './exp-dot'
import watchClkDot from './clk-dot'

export default function launch() {
  watchExpDot()
  watchClkDot()
}
